import { takeLatest, put } from 'redux-saga/effects'
import { Types } from '../ducks/forms'
import oikosApi from '../../services/oikos'
import { notifyError } from '../../utils/notify'

function* getFieldsForActivitiesBySector() {
  try {
    const res = yield oikosApi.get('/', {
      table: 'setorAtiv',
      action: 'generate_form',
    })
    console.tron.log('res getFieldsForActivitiesBySector', res)

    yield put({ type: Types.GET_FIELDS_FOR_ACTIVITIES_BY_SECTOR_SUCCEEDED, payload: res.data })
  } catch (err) {
    console.tron.log('GET_FIELDS_FOR_ACTIVITIES_BY_SECTOR_FAILED', err)
    notifyError('Não foi possível listar os campos do formulário de Atividades.')
    yield put({ type: Types.GET_FIELDS_FOR_ACTIVITIES_BY_SECTOR_FAILED, payload: err })
  }
}

function* getFieldsForDepartments() {
  try {
    const res = yield oikosApi.get('/', {
      table: 'dpto',
      action: 'generate_form',
    })
    console.tron.log('res getFieldsForDepartments', res)

    yield put({ type: Types.GET_FIELDS_FOR_DEPARTMENTS_SUCCEEDED, payload: res.data })
  } catch (err) {
    console.tron.log('GET_FIELDS_FOR_DEPARTMENTS_FAILED', err)
    notifyError('Não foi possível listar os campos do formulário de Departamentos.')
    yield put({ type: Types.GET_FIELDS_FOR_DEPARTMENTS_FAILED, payload: err })
  }
}

function* getFieldsForSectors() {
  try {
    const res = yield oikosApi.get('/', {
      table: 'setor',
      action: 'generate_form',
    })
    console.tron.log('res getFieldsForSectors', res)

    yield put({ type: Types.GET_FIELDS_FOR_SECTORS_SUCCEEDED, payload: res.data })
  } catch (err) {
    console.tron.log('GET_FIELDS_FOR_SECTORS_FAILED', err)
    notifyError('Não foi possível listar os campos do formulário de Setores.')
    yield put({ type: Types.GET_FIELDS_FOR_SECTORS_FAILED, payload: err })
  }
}

function* getFieldsForServices() {
  try {
    const res = yield oikosApi.get('/', {
      table: 'servico',
      action: 'generate_form',
    })
    console.tron.log('res getFieldsForServices', res)

    yield put({ type: Types.GET_FIELDS_FOR_SERVICES_SUCCEEDED, payload: res.data })
  } catch (err) {
    console.tron.log('GET_FIELDS_FOR_SERVICES_FAILED', err)
    notifyError('Não foi possível listar os campos do formulário de Serviços.')
    yield put({ type: Types.GET_FIELDS_FOR_SERVICES_FAILED, payload: err })
  }
}

function* getFieldsForLegalEntities() {
  try {
    const res = yield oikosApi.get('/', {
      table: 'pj',
      action: 'generate_form',
    })
    console.tron.log('res getFieldsForLegalEntities', res)

    yield put({ type: Types.GET_FIELDS_FOR_LEGAL_ENTITIES_SUCCEEDED, payload: res.data })
  } catch (err) {
    console.tron.log('GET_FIELDS_FOR_LEGAL_ENTITIES_FAILED', err)
    notifyError('Não foi possível listar os campos do formulário de Pessoa Jurídica.')
    yield put({ type: Types.GET_FIELDS_FOR_LEGAL_ENTITIES_FAILED, payload: err })
  }
}

export const formsSagas = [
  takeLatest(Types.GET_FIELDS_FOR_ACTIVITIES_BY_SECTOR_REQUESTED, getFieldsForActivitiesBySector),
  takeLatest(Types.GET_FIELDS_FOR_DEPARTMENTS_REQUESTED, getFieldsForDepartments),
  takeLatest(Types.GET_FIELDS_FOR_SECTORS_REQUESTED, getFieldsForSectors),
  takeLatest(Types.GET_FIELDS_FOR_SERVICES_REQUESTED, getFieldsForServices),
  takeLatest(Types.GET_FIELDS_FOR_LEGAL_ENTITIES_REQUESTED, getFieldsForLegalEntities),
]
